import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { PageType } from "../constants";
import { Programs } from "../models/programsConfig";
import { capabilitiesActions } from "../redux/actions/capabilitiesActions";
import { crmActions } from "../redux/actions/crmApiActions";
import { getIsInitialCrmFetchDone } from "../redux/selectors";
import { getOnboardingSignedIn } from "../redux/selectors/authSelectors";

export const ProgramSearchParam = "program";
export const FormIdSearchParam = "form-id";
export const SubFormIdSearchParam = "sub-form-id";
export const GameConceptIdSearchParam = "game-concept-id";
export const PitchConceptIdSearchParam = "pitch-concept-id";

export const useFetchCrmData = (pageType: PageType | undefined) => {
  const dispatch = useDispatch();
  const isInitialCrmFetchDone = useSelector(getIsInitialCrmFetchDone);
  const isSigned = useSelector(getOnboardingSignedIn);
  useEffect(() => {
    if (!pageType || !isSigned || isInitialCrmFetchDone) {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    switch (pageType) {
      case PageType.IdXboxApplication:
        dispatch(
          crmActions.fetchCrmData.start(
            pageType,
            Programs.IdXbox,
            searchParams.get(GameConceptIdSearchParam) ?? undefined
          )
        );
        break;
      case PageType.IdAzureApplication:
        dispatch(crmActions.fetchCrmData.start(pageType, Programs.IdAzure, undefined));
        break;
      case PageType.PitchApplication:
        dispatch(crmActions.fetchCrmData.start(pageType, Programs.Pitch, undefined));
        break;
      case PageType.AaaApplication:
        dispatch(
          crmActions.fetchCrmData.start(
            pageType,
            Programs.Aaa,
            searchParams.get(GameConceptIdSearchParam) ?? undefined
          )
        );
        break;
      case PageType.ProgramSelection:
        dispatch(capabilitiesActions.updateCapabilities.start());
        break;
    }
  }, [dispatch, isInitialCrmFetchDone, isSigned, pageType]);
};
